(function() {
  const escapeHtml = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const splitFeatures = (value) => String(value || '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const boot = (root) => {
    if (!root || root.dataset.lbecReady === 'true') return;
    root.dataset.lbecReady = 'true';

    const configNode = root.querySelector('[data-dq-config]');
    let config = { categories: [], offers: [] };
    if (configNode) {
      try {
        config = JSON.parse(configNode.textContent || '{}');
      } catch (error) {
        config = { categories: [], offers: [] };
      }
    }

    const categories = Array.isArray(config.categories) ? config.categories.filter((item) => item && item.slot && item.label) : [];
    const offers = Array.isArray(config.offers) ? config.offers.map((offer) => ({
      ...offer,
      priceValue: Number(offer.priceValue || 0),
      maxQty: Math.max(1, Number(offer.maxQty || 1)),
      allowMultiple: offer.allowMultiple === true,
      featured: offer.featured === true,
      features: splitFeatures(offer.featuresText),
      recurringUnit: String(offer.recurringUnit || '').trim(),
      badge: String(offer.badge || '').trim(),
      buttonText: String(offer.buttonText || 'Add to quote').trim() || 'Add to quote',
    })) : [];

    const categoryMap = new Map(categories.map((category) => [category.slot, category]));
    const supportCategory = categories.find((category) => category.slot === 'cat_4') || null;

    const stageEls = {
      category: root.querySelector('[data-dq-stage="category"]'),
      primary: root.querySelector('[data-dq-stage="primary"]'),
      extras: root.querySelector('[data-dq-stage="extras"]'),
      done: root.querySelector('[data-dq-stage="done"]'),
    };
    const stepIndicators = root.querySelectorAll('[data-dq-step-indicator]');
    const backButton = root.querySelector('[data-dq-back]');
    const categoryChoices = root.querySelector('[data-dq-category-choices]');
    const primaryHeading = root.querySelector('[data-dq-primary-heading]');
    const primaryText = root.querySelector('[data-dq-primary-text]');
    const selectedCategory = root.querySelector('[data-dq-selected-category]');
    const primaryOptions = root.querySelector('[data-dq-primary-options]');
    const extrasHeading = root.querySelector('[data-dq-extras-heading]');
    const extrasText = root.querySelector('[data-dq-extras-text]');
    const selectedPrimary = root.querySelector('[data-dq-selected-primary]');
    const extrasShell = root.querySelector('[data-dq-extras-shell]');
    const supportPrompt = root.querySelector('[data-dq-support-prompt]');
    const supportShell = root.querySelector('[data-dq-support-shell]');
    const doneSummary = root.querySelector('[data-dq-done-summary]');

    const estimateBox = root.querySelector('[data-dq-estimatebox]');
    const tierText = root.querySelector('[data-dq-tiertext]');
    const estimateUnit = root.querySelector('[data-dq-estimate-unit]');
    const estimateMeta = root.querySelector('[data-dq-estimate-meta]');
    const summaryList = root.querySelector('[data-dq-summary-list]');
    const emptyState = root.querySelector('[data-dq-empty]');
    const clearButton = root.querySelector('[data-dq-clear]');
    const totalOnce = root.querySelector('[data-dq-total-once]');
    const totalRecurring = root.querySelector('[data-dq-total-recurring]');
    const recurringCard = root.querySelector('[data-dq-recurring-card]');
    const summaryInput = root.querySelector('[data-dq-summary-input]');
    const jsonInput = root.querySelector('[data-dq-json-input]');
    const onceInput = root.querySelector('[data-dq-once-input]');
    const recurringInput = root.querySelector('[data-dq-recurring-input]');
    const appStatusInput = root.querySelector('[data-dq-app-status-input]');
    const appQuoteInput = root.querySelector('[data-dq-app-quote-input]');
    const appClientInput = root.querySelector('[data-dq-app-client-input]');
    const submissionTokenInput = root.querySelector('[data-dq-submission-token-input]');
    const submitButton = root.querySelector('[data-dq-submit]');
    const form = root.querySelector('form');
    const appQuoteSyncEnabled = root.dataset.appQuoteSync === 'true';
    const appQuoteBase = String(root.dataset.appQuoteBase || '').trim().replace(/\/$/, '');
    const appQuoteSource = String(root.dataset.appQuoteSource || 'Website design quote builder').trim() || 'Website design quote builder';

    const money = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    });

    const TIER_CLASSES = ['tier-basic', 'tier-advanced', 'tier-pro', 'tier-elite'];
    const TIER_DEFS = [
      { key: 'basic', label: 'Basic', cls: 'tier-basic' },
      { key: 'advanced', label: 'Advanced', cls: 'tier-advanced' },
      { key: 'pro', label: 'Pro', cls: 'tier-pro' },
      { key: 'elite', label: 'Elite', cls: 'tier-elite' },
    ];

    const state = {
      items: new Map(),
      tierKey: 'basic',
    };

    const flow = {
      stage: 'category',
      categorySlot: '',
      primaryOfferId: '',
      supportOpen: false,
      supportDismissed: false,
      sessionItemIds: [],
      resetTimer: null,
    };

    const buildSubmissionToken = () => {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `lbec-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    };

    if (submissionTokenInput && !submissionTokenInput.value) {
      submissionTokenInput.value = buildSubmissionToken();
    }

    const fieldValue = (fieldName) => {
      if (!form) return '';
      const field = form.querySelector(`[name="${fieldName}"]`);
      return field ? String(field.value || '').trim() : '';
    };

    const getCategory = (slot) => categoryMap.get(slot) || null;
    const getOffer = (id) => offers.find((offer) => offer.id === id) || null;
    const getOffersForSlot = (slot) => offers.filter((offer) => offer.categorySlot === slot);
    const getPrimaryOffers = (slot) => getOffersForSlot(slot).filter((offer) => offer.displayStyle !== 'extra');
    const getExtraOffers = (slot) => getOffersForSlot(slot).filter((offer) => offer.displayStyle === 'extra');
    const getSupportOffers = () => supportCategory ? getOffersForSlot(supportCategory.slot) : [];

    const categoryQuestion = (category) => {
      if (!category) return 'Choose the main service';
      if (category.slot === 'cat_1') return `What kind of ${category.label.toLowerCase()} do you need?`;
      if (category.slot === 'cat_2') return 'What kind of artwork help do you need?';
      if (category.slot === 'cat_3') return 'What kind of label project do you need?';
      if (category.slot === 'cat_4') return 'What kind of branding or support do you need?';
      return `Which ${category.label.toLowerCase()} path fits best?`;
    };

    const buildSummaryText = (items) => items.map((item) => {
      const qtyPart = item.qty > 1 ? ` x${item.qty}` : '';
      const recurringPart = item.recurring ? ` ${item.recurring}` : '';
      return `${item.category}: ${item.title}${qtyPart} - ${item.priceLabel}${recurringPart}`;
    }).join(' | ');

    const buildStorefrontQuotePayload = () => {
      const items = Array.from(state.items.values()).map((item) => ({
        id: item.id,
        title: item.title,
        mode: 'design',
        category: item.category,
        group: item.group,
        layout: item.layout,
        price: item.price,
        price_label: item.priceLabel,
        recurring: item.recurring,
        qty: item.qty,
        subtotal: Number(item.price || 0) * Number(item.qty || 0),
      }));

      return {
        submission_token: submissionTokenInput ? submissionTokenInput.value : buildSubmissionToken(),
        source_name: appQuoteSource,
        builder_mode: 'design',
        builder_label: 'Website design quote builder',
        builder_variant: 'shopify_design_quote_builder',
        page_url: window.location.href,
        package_summary: summaryInput ? summaryInput.value : '',
        one_time_estimate: onceInput ? onceInput.value : '',
        recurring_estimate: recurringInput ? recurringInput.value : '',
        contact: {
          name: fieldValue('contact[name]'),
          email: fieldValue('contact[email]'),
          company: fieldValue('contact[Company]'),
          timeline: fieldValue('contact[Timeline]'),
          notes: fieldValue('contact[Notes]'),
        },
        items,
      };
    };

    const persistForm = (items, onceTotal, recurringTotal) => {
      const summary = buildSummaryText(items);
      if (summaryInput) summaryInput.value = summary;
      if (jsonInput) jsonInput.value = JSON.stringify(items);
      if (onceInput) onceInput.value = money.format(onceTotal);
      if (recurringInput) recurringInput.value = recurringTotal > 0 ? money.format(recurringTotal) : '';
      if (submitButton) submitButton.disabled = items.length === 0;
    };

    const getTierForState = (items, onceTotal, recurringTotal) => {
      let score = 0;
      const categoriesSet = new Set();

      items.forEach((item) => {
        categoriesSet.add(item.category);
        const layoutWeight = item.layout === 'feature' ? 4 : item.layout === 'package' ? 3 : 1;
        score += layoutWeight * Math.max(1, item.qty);
        if (item.featured) score += 2;
        if (item.recurring) score += 1;
      });

      score += categoriesSet.size * 2;

      if (onceTotal >= 4000) score += 6;
      else if (onceTotal >= 2000) score += 4;
      else if (onceTotal >= 800) score += 2;

      if (recurringTotal >= 500) score += 2;
      else if (recurringTotal > 0) score += 1;

      if (score >= 18) return TIER_DEFS[3];
      if (score >= 11) return TIER_DEFS[2];
      if (score >= 5) return TIER_DEFS[1];
      return TIER_DEFS[0];
    };

    const applyTier = (tier) => {
      if (!estimateBox || !tierText) return;
      const nextKey = tier && tier.key ? tier.key : 'basic';
      const changed = state.tierKey !== nextKey;
      tierText.textContent = tier && tier.label ? tier.label : 'Basic';
      estimateBox.classList.remove(...TIER_CLASSES);
      if (tier && tier.cls) estimateBox.classList.add(tier.cls);
      estimateBox.setAttribute('data-tier', nextKey);
      if (changed) {
        estimateBox.classList.remove('tier-animate');
        void estimateBox.offsetWidth;
        estimateBox.classList.add('tier-animate');
        setTimeout(() => {
          estimateBox.classList.remove('tier-animate');
        }, 1200);
      }
      state.tierKey = nextKey;
    };

    const getItemFromOffer = (offer) => {
      const category = getCategory(offer.categorySlot);
      return {
        id: offer.id,
        title: offer.title || 'Design offer',
        category: category ? category.label : '',
        group: 'design',
        layout: offer.displayStyle || 'package',
        featured: offer.featured === true,
        price: Number(offer.priceValue || 0),
        priceLabel: offer.priceLabel || '$0',
        recurring: offer.recurringUnit || '',
        allowMultiple: offer.allowMultiple === true,
        minQty: 1,
        maxQty: Math.max(1, Number(offer.maxQty || 1)),
      };
    };

    const addOfferToState = (offer, forceReplace) => {
      const item = getItemFromOffer(offer);
      const existing = state.items.get(item.id);

      if (forceReplace && flow.primaryOfferId && flow.primaryOfferId !== item.id) {
        state.items.delete(flow.primaryOfferId);
        flow.sessionItemIds = flow.sessionItemIds.filter((id) => id !== flow.primaryOfferId);
      }

      if (existing) {
        if (item.allowMultiple && existing.qty < item.maxQty) {
          existing.qty += 1;
        }
      } else {
        state.items.set(item.id, {
          ...item,
          qty: item.minQty,
        });
      }

      if (!flow.sessionItemIds.includes(item.id)) {
        flow.sessionItemIds.push(item.id);
      }
    };

    const changeQty = (id, delta) => {
      const item = state.items.get(id);
      if (!item) return;
      const nextQty = item.qty + delta;
      if (nextQty < item.minQty) {
        state.items.delete(id);
      } else {
        item.qty = Math.min(item.maxQty, nextQty);
      }
      render();
    };

    const setStage = (name) => {
      flow.stage = name;
      Object.entries(stageEls).forEach(([key, node]) => {
        if (!node) return;
        const active = key === name;
        node.hidden = !active;
        node.classList.toggle('is-active', active);
      });
      stepIndicators.forEach((indicator) => {
        const active = indicator.dataset.dqStepIndicator === name;
        indicator.classList.toggle('is-active', active);
      });
      if (backButton) {
        backButton.hidden = name === 'category' || name === 'done';
      }
    };

    const cancelResetTimer = () => {
      if (flow.resetTimer) {
        window.clearTimeout(flow.resetTimer);
        flow.resetTimer = null;
      }
    };

    const resetFlow = () => {
      cancelResetTimer();
      flow.categorySlot = '';
      flow.primaryOfferId = '';
      flow.supportOpen = false;
      flow.supportDismissed = false;
      flow.sessionItemIds = [];
      setStage('category');
      renderGuide();
    };

    const finishFlow = () => {
      setStage('done');
      renderGuide();
      cancelResetTimer();
      flow.resetTimer = window.setTimeout(() => {
        resetFlow();
      }, 2200);
    };

    const renderCategoryCards = () => {
      if (!categoryChoices) return;
      categoryChoices.innerHTML = categories.map((category) => {
        const catOffers = getOffersForSlot(category.slot);
        const prices = catOffers.map((offer) => Number(offer.priceValue || 0)).filter((price) => price > 0);
        const fromPrice = prices.length ? Math.min(...prices) : 0;
        return `
          <button type="button" class="lbec-dq__choiceCard" data-dq-action="select-category" data-category-slot="${escapeHtml(category.slot)}">
            <span class="lbec-dq__choiceBadge">${escapeHtml(category.label)}</span>
            <strong>${escapeHtml(category.label)}</strong>
            <p>${escapeHtml(category.description || '')}</p>
            <span class="lbec-dq__choiceArrow">${fromPrice > 0 ? `From ${escapeHtml(money.format(fromPrice))}` : 'Build request'}</span>
          </button>
        `;
      }).join('');
    };

    const renderOfferCard = (offer, mode) => {
      const buttonLabel = mode === 'primary' ? 'Add to quote' : offer.buttonText;
      const isAdded = state.items.has(offer.id);
      const buttonText = mode === 'primary'
        ? buttonLabel
        : (isAdded && !offer.allowMultiple ? 'Added' : (isAdded && offer.allowMultiple ? 'Add another' : buttonLabel));
      const features = offer.features.map((line) => `<li>${escapeHtml(line)}</li>`).join('');
      const badge = offer.badge ? `<span class="lbec-dq__badge">${escapeHtml(offer.badge)}</span>` : '';
      const recurring = offer.recurringUnit ? `<small>${escapeHtml(offer.recurringUnit)}</small>` : '';
      const cardClass = offer.displayStyle === 'feature' ? 'lbec-dq__featurecard' : 'lbec-dq__packagecard';
      return `
        <article class="${cardClass}${offer.featured ? ' is-featured' : ''}">
          <div class="lbec-dq__cardframe">
            <div class="lbec-dq__cardtop">
              <div>
                ${badge}
                <h4>${escapeHtml(offer.title)}</h4>
                ${offer.subtitle ? `<p>${escapeHtml(offer.subtitle)}</p>` : ''}
              </div>
              <div class="lbec-dq__pricepill">
                <strong>${escapeHtml(offer.priceLabel || '$0')}</strong>
                ${recurring}
              </div>
            </div>
            ${features ? `<ul class="lbec-dq__featurelist">${features}</ul>` : ''}
          </div>
          <button type="button" class="lbec-dq__add${isAdded && mode !== 'primary' && !offer.allowMultiple ? ' is-added' : ''}" data-dq-action="${mode === 'primary' ? 'select-primary' : 'add-offer'}" data-offer-id="${escapeHtml(offer.id)}">${escapeHtml(buttonText)}</button>
        </article>
      `;
    };

    const renderExtraRow = (offer) => {
      const isAdded = state.items.has(offer.id);
      const buttonText = isAdded && !offer.allowMultiple ? 'Added' : (isAdded && offer.allowMultiple ? 'Add another' : offer.buttonText || 'Add');
      const badge = offer.badge ? `<span class="lbec-dq__badge">${escapeHtml(offer.badge)}</span>` : '';
      const recurring = offer.recurringUnit ? `<small>${escapeHtml(offer.recurringUnit)}</small>` : '';
      return `
        <article class="lbec-dq__extrarow">
          <div class="lbec-dq__rowcopy">
            <div>
              ${badge}
              <strong>${escapeHtml(offer.title)}</strong>
            </div>
            ${offer.subtitle ? `<p>${escapeHtml(offer.subtitle)}</p>` : ''}
          </div>
          <div class="lbec-dq__rowactions">
            <div class="lbec-dq__rowprice">
              <strong>${escapeHtml(offer.priceLabel || '$0')}</strong>
              ${recurring}
            </div>
            <button type="button" class="lbec-dq__miniadd${isAdded && !offer.allowMultiple ? ' is-added' : ''}" data-dq-action="add-offer" data-offer-id="${escapeHtml(offer.id)}">${escapeHtml(buttonText)}</button>
          </div>
        </article>
      `;
    };

    const renderGuide = () => {
      renderCategoryCards();

      const category = getCategory(flow.categorySlot);
      const primaryOffers = category ? getPrimaryOffers(category.slot) : [];
      const extraOffers = category ? getExtraOffers(category.slot) : [];
      const supportOffers = category && category.slot === 'cat_1' ? getSupportOffers() : [];
      const primaryOffer = getOffer(flow.primaryOfferId);

      if (selectedCategory) {
        if (category) {
          selectedCategory.hidden = false;
          selectedCategory.innerHTML = `
            <span class="lbec-dq__selectionLabel">Chosen design type</span>
            <strong>${escapeHtml(category.label)}</strong>
          `;
        } else {
          selectedCategory.hidden = true;
          selectedCategory.innerHTML = '';
        }
      }

      if (primaryHeading) primaryHeading.textContent = categoryQuestion(category);
      if (primaryText) primaryText.textContent = '';

      if (primaryOptions) {
        if (primaryOffers.length) {
          primaryOptions.innerHTML = `<div class="lbec-dq__packagegrid">${primaryOffers.map((offer) => renderOfferCard(offer, 'primary')).join('')}</div>`;
        } else {
          primaryOptions.innerHTML = `
            <div class="lbec-dq__emptycat">
              <strong>No starting services added yet.</strong>
              <p>Add a <em>Design Offer</em> block for this design type to build the guided flow.</p>
            </div>
          `;
        }
      }

      if (selectedPrimary) {
        if (primaryOffer) {
          selectedPrimary.hidden = false;
          selectedPrimary.innerHTML = `
            <span class="lbec-dq__selectionLabel">Main service selected</span>
            <strong>${escapeHtml(primaryOffer.title)}</strong>
            <span>${escapeHtml(primaryOffer.priceLabel || '$0')}</span>
          `;
        } else {
          selectedPrimary.hidden = true;
          selectedPrimary.innerHTML = '';
        }
      }

      if (extrasHeading) {
        extrasHeading.textContent = category && category.slot === 'cat_1' ? 'Add features or support?' : 'Anything else to add?';
      }
      if (extrasText) {
        extrasText.textContent = category && category.slot === 'cat_1'
          ? 'Add storefront features, tools, or support before we wrap this request and send you back to the main chooser.'
          : 'Optional add-ons can be layered in here before you finish this request.';
      }

      if (extrasShell) {
        if (extraOffers.length) {
          extrasShell.innerHTML = `
            <div class="lbec-dq__extrasHead">
              <strong>Optional add-ons</strong>
              <span>Pick any extras you want to stack onto this request.</span>
            </div>
            <div class="lbec-dq__extralist">${extraOffers.map((offer) => renderExtraRow(offer)).join('')}</div>
          `;
        } else {
          extrasShell.innerHTML = `
            <div class="lbec-dq__emptycat">
              <strong>No add-ons in this step.</strong>
              <p>You can finish this request now or go back and choose a different starting path.</p>
            </div>
          `;
        }
      }

      if (supportPrompt) {
        const showPrompt = supportOffers.length > 0 && !flow.supportOpen && !flow.supportDismissed;
        supportPrompt.hidden = !showPrompt;
      }

      if (supportShell) {
        if (flow.supportOpen && supportOffers.length) {
          supportShell.hidden = false;
          supportShell.innerHTML = `
            <div class="lbec-dq__extrasHead">
              <strong>${escapeHtml(supportCategory ? supportCategory.label : 'Support')} options</strong>
              <span>Layer in support or consulting if you want follow-up help after the main build.</span>
            </div>
            <div class="lbec-dq__packagegrid">${supportOffers.map((offer) => renderOfferCard(offer, 'extra')).join('')}</div>
          `;
        } else {
          supportShell.hidden = true;
          supportShell.innerHTML = '';
        }
      }

      if (doneSummary) {
        const currentItems = flow.sessionItemIds
          .map((id) => state.items.get(id))
          .filter(Boolean);
        doneSummary.innerHTML = currentItems.length ? `
          <div class="lbec-dq__doneList">
            ${currentItems.map((item) => `
              <div class="lbec-dq__doneItem">
                <strong>${escapeHtml(item.title)}</strong>
                <span>${escapeHtml(item.priceLabel)}${item.qty > 1 ? ` x${item.qty}` : ''}</span>
              </div>
            `).join('')}
          </div>
        ` : '';
      }
    };

    const render = () => {
      const items = Array.from(state.items.values());
      summaryList.innerHTML = '';

      if (!items.length) {
        if (emptyState) {
          emptyState.hidden = false;
          summaryList.appendChild(emptyState);
        }
        if (clearButton) clearButton.hidden = true;
        totalOnce.textContent = money.format(0);
        totalRecurring.textContent = money.format(0);
        if (estimateUnit) estimateUnit.textContent = 'Add items to see your estimate build up.';
        if (estimateMeta) estimateMeta.textContent = '0 offers selected';
        if (recurringCard) recurringCard.hidden = true;
        applyTier(TIER_DEFS[0]);
        persistForm([], 0, 0);
        renderGuide();
        return;
      }

      if (emptyState) emptyState.hidden = true;
      if (clearButton) clearButton.hidden = false;

      let onceTotal = 0;
      let recurringTotal = 0;
      const categoriesSet = new Set();
      let totalQty = 0;

      items.forEach((item) => {
        categoriesSet.add(item.category);
        totalQty += item.qty;
        const subtotal = item.price * item.qty;
        if (item.recurring) recurringTotal += subtotal;
        else onceTotal += subtotal;

        const card = document.createElement('article');
        card.className = 'lbec-dq__estimateLine';
        card.innerHTML = `
          <div class="lbec-dq__lineTop">
            <div class="lbec-dq__lineTitle">
              <strong>${escapeHtml(item.title)}</strong>
              <span>${escapeHtml(item.category)}${item.recurring ? ` - ${escapeHtml(item.recurring)}` : ''}</span>
            </div>
            <div class="lbec-dq__linePrice">
              <strong>${money.format(subtotal)}</strong>
              <span>${escapeHtml(item.priceLabel)}${item.qty > 1 ? ` - qty ${item.qty}` : ''}</span>
            </div>
          </div>
          <div class="lbec-dq__lineBottom">
            <div class="lbec-dq__qty">
              <button type="button" data-dq-dec="${escapeHtml(item.id)}" aria-label="Reduce quantity">-</button>
              <span>${item.qty}</span>
              <button type="button" data-dq-inc="${escapeHtml(item.id)}" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="lbec-dq__remove" data-dq-remove="${escapeHtml(item.id)}">Remove</button>
          </div>
        `;
        summaryList.appendChild(card);
      });

      totalOnce.textContent = money.format(onceTotal);
      totalRecurring.textContent = money.format(recurringTotal);
      if (recurringCard) recurringCard.hidden = recurringTotal <= 0;
      if (estimateUnit) {
        estimateUnit.textContent = categoriesSet.size > 1
          ? `${categoriesSet.size} categories combined into one request.`
          : 'One category selected so far.';
      }
      if (estimateMeta) {
        estimateMeta.textContent = `${totalQty} ${totalQty === 1 ? 'offer' : 'offers'} selected`;
      }

      applyTier(getTierForState(items, onceTotal, recurringTotal));
      persistForm(items, onceTotal, recurringTotal);
      renderGuide();
    };

    root.addEventListener('click', (event) => {
      const actionNode = event.target.closest('[data-dq-action]');
      if (actionNode) {
        const action = actionNode.dataset.dqAction;
        if (action === 'select-category') {
          cancelResetTimer();
          flow.categorySlot = actionNode.dataset.categorySlot || '';
          flow.primaryOfferId = '';
          flow.supportOpen = false;
          flow.supportDismissed = false;
          flow.sessionItemIds = [];
          setStage('primary');
          renderGuide();
          return;
        }
        if (action === 'select-primary') {
          const offer = getOffer(actionNode.dataset.offerId);
          if (!offer) return;
          flow.primaryOfferId = offer.id;
          flow.supportOpen = false;
          flow.supportDismissed = false;
          addOfferToState(offer, true);
          const extraOffers = getExtraOffers(flow.categorySlot);
          const supportOffers = flow.categorySlot === 'cat_1' ? getSupportOffers() : [];
          if (extraOffers.length || supportOffers.length) {
            setStage('extras');
          } else {
            finishFlow();
          }
          render();
          return;
        }
        if (action === 'add-offer') {
          const offer = getOffer(actionNode.dataset.offerId);
          if (!offer) return;
          addOfferToState(offer, false);
          render();
          return;
        }
      }

      const supportChoice = event.target.closest('[data-dq-support-choice]');
      if (supportChoice) {
        flow.supportOpen = supportChoice.dataset.dqSupportChoice === 'show';
        flow.supportDismissed = supportChoice.dataset.dqSupportChoice === 'skip';
        renderGuide();
        return;
      }

      if (event.target.closest('[data-dq-finish]')) {
        finishFlow();
        return;
      }

      if (event.target.closest('[data-dq-reset-now]')) {
        resetFlow();
        return;
      }

      if (event.target.closest('[data-dq-back]')) {
        cancelResetTimer();
        if (flow.stage === 'primary') {
          resetFlow();
          return;
        }
        if (flow.stage === 'extras') {
          setStage('primary');
          renderGuide();
        }
      }
    });

    summaryList.addEventListener('click', (event) => {
      const dec = event.target.closest('[data-dq-dec]');
      const inc = event.target.closest('[data-dq-inc]');
      const remove = event.target.closest('[data-dq-remove]');
      if (dec) changeQty(dec.dataset.dqDec, -1);
      if (inc) changeQty(inc.dataset.dqInc, 1);
      if (remove) {
        state.items.delete(remove.dataset.dqRemove);
        flow.sessionItemIds = flow.sessionItemIds.filter((id) => id !== remove.dataset.dqRemove);
        if (flow.primaryOfferId === remove.dataset.dqRemove) {
          flow.primaryOfferId = '';
        }
        render();
      }
    });

    if (clearButton) {
      clearButton.addEventListener('click', () => {
        state.items.clear();
        resetFlow();
        render();
      });
    }

    if (form) {
      form.addEventListener('submit', async (event) => {
        if (form.dataset.appBridgeComplete === 'true') return;
        if (!appQuoteSyncEnabled || !appQuoteBase || typeof window.fetch !== 'function') {
          if (appStatusInput) appStatusInput.value = 'App quote sync skipped.';
          return;
        }
        event.preventDefault();
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.dataset.originalLabel = submitButton.dataset.originalLabel || submitButton.textContent || '';
          submitButton.textContent = 'Sending...';
        }
        const payload = buildStorefrontQuotePayload();
        try {
          const response = await fetch(`${appQuoteBase}/api/storefront/quotes/request`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
          let result = {};
          try {
            result = await response.json();
          } catch (error) {
            result = {};
          }
          if (!response.ok || !result.ok) {
            throw new Error(result.detail || result.error || 'Unable to sync the design quote request into Order Master.');
          }
          if (appStatusInput) {
            appStatusInput.value = result.existing
              ? `Synced to Order Master (${result.quote_no}, existing record)`
              : `Synced to Order Master (${result.quote_no})`;
          }
          if (appQuoteInput) appQuoteInput.value = result.quote_no || '';
          if (appClientInput) appClientInput.value = result.client_name || '';
        } catch (error) {
          if (appStatusInput) {
            appStatusInput.value = `Order Master sync failed - email backup only: ${error instanceof Error ? error.message : 'Unknown error'}`;
          }
        }
        form.dataset.appBridgeComplete = 'true';
        form.submit();
      });
    }

    render();
  };

  const init = () => {
    document.querySelectorAll('[data-lbec-dq]').forEach(boot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
